// Outcome of a log/prepare call. The portal polls the prepare endpoint until the status is
// terminal (Ready or Unavailable) and only then opens the SSE stream. Mirror of the C# enum
// in MadCloud.Services.Domain.LiveLog.LogPrepareStatus.
export enum LogPrepareStatus {
  Ready = 0,
  Loading = 1,
  Unavailable = 2
}
